module.exports = __webpack_public_path__ + "static/img/img-install-tag-truck-detail.331676f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-truck-detail.svg
// module id = 1794
// module chunks = 1